import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/user-roles/new/loading';

export const Route = createFileRoute('/_private/settings/user-roles/new')({
  component: Loading,
});
